import axios from '../common/axios.js'
import _ from 'lodash'
import Utils from '../common/utils.js'
import CustomInput from '../common/forms/Input.vue'
import Select from '../common/forms/Select.vue'
import Loading from '../common/ui/loading_inex.vue'
import LoadingBtn from '../common/ui/loading_btn.vue'
import assert_options from 'locutus/php/info/assert_options'

export default {
	mixins: [Utils],
	data() {
		return {
			columns: [],
			users: [],
			search: '',
			filters: {},
			number_returned: 0,
			total_users: 0,
			sort: 'last_company_update',
			sortDirection: 'desc',
			page: 0,
			loading: true,
			loading_users: true,
			users_cancel_token: null,
			error_loading: false
		}
	},
	created(){
		let self = this;

		this.debouncedGetUsers = _.debounce(() => {
			this.getUsers(true);
		}, 300);

		//Récupération des colonnes
		axios.get('api=inex/views/{view_code}/users/gestion/config')
			.then(function (response) {
				self.columns = response.data;
				self.loading = false;
				self.getUsers();				
			}).catch(function (error) {
				self.error_loading = true;
				self.loading = false;
				self.loading_users = false;
			})		
	},
	mounted() {
		this.setupIntersectionObserver();
	},
	watch: {
		filters: {
			handler(newVal) {
				this.debouncedGetUsers();
			},
			deep: true
		},
		search: {
			handler(newVal, oldVal) {
				this.debouncedGetUsers();				
			}
		},
		sort: {
			handler(newVal) {
				this.debouncedGetUsers();
			}
		},
		sortDirection: {
			handler(newVal) {
				this.debouncedGetUsers();
			}
		}
	},
	methods: {
		inviteUser(){
			this.$store.dispatch('open_modal', 'invite_user')
		},
		getUsers(reset = false){
			let self = this;
			if(reset){
				this.page = 0;
				this.users = [];
			}
			let offset = this.users.length;
			let params = {
				offset,
				sort: null,
				search: null
			}

			//RZ--> Si on a un tri, on l'ajoute aux paramètres
			if(this.sort){
				let direction = this.sortDirection == 'asc' ? '1' : '-1';
				params.sort = this.sort+','+direction;
			}
			
			//RZ--> Si on a une recherche, on l'ajoute aux paramètres
			if(this.search && this.search.length >= 3){
				params.search = this.search;
			}

			//RZ--> Si on a des filtres, on les ajoute aux paramètres
			if(this.filters){
				_.forEach(this.filters, function(value, key){
					params[key] = value;
				});
			}			
			
			if(this.page == 0){
				self.loading_users = true;
			}

			if(this.total_users != 0 && this.total_users <= this.users.length){			
				this.loading_users = false;
				if(this.observer) this.observer.disconnect();
				return;
			}

			//AS--> Annulation de la requête précédente si elle existe
			if(this.users_cancel_token){
				this.users_cancel_token.cancel();
			}
			this.users_cancel_token = axios.CancelToken.source();

			axios.get('api=inex/views/{view_code}/users/gestion', {params, cancelToken: this.users_cancel_token.token})
				.then(function (response) {
					if(response.data.data.length > 0){
						if(self.page == 0){
							self.users = response.data.data;
						}else{
							self.users = [...self.users, ...response.data.data];
						}
						self.number_returned = parseInt(response.data.number_returned);
						self.total_users = parseInt(response.data.total);
						
						self.setupIntersectionObserver();
					}
				}).catch(function (error) {
					console.log('==> error', error);
				}).finally(function () {
					self.loading_users = false;
				})
	
		},
		setupIntersectionObserver() {
			let self = this;
			const container = document.querySelector('.tableau_recherches_container');
			const options = {
				root: container, // viewport
				rootMargin: '100px', // charge 100px avant d'atteindre le bas
				threshold: 0.1
			};
			
			if(this.observer) this.observer.disconnect();
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting && !self.loading_users && self.users.length > 0) {
						self.loadMore();
					}
				});
			}, options);
			
			// Observer l'élément sentinelle (dernière ligne ou div de fin)
			const sentinel = self.$refs.sentinel;
			if (sentinel) {
				this.observer.observe(sentinel);
			}
		},
		loadMore() {
			this.page++;
			this.getUsers();
		},
		getSelectData(column, user){
			let options = {
				value: user[column.code].value,
				label: column.label,
				haut: true,
				field: column.code,
				w100: true,
				theme: this.getTheme(column),
				options: this.formatOptions(column.options, column.code),
				disabled: column.modified == false,
			}			

			if(column.nullable_label_edit){
				options.empty = null;
				options.empty_label = this.i18n(column.nullable_label_edit);
			}
			if(column.nullable_label_view){
				options.empty_label_selected = this.i18n(column.nullable_label_view);
			}
			if(column.nullable_color_view){
				options.empty_color = column.nullable_color_view;
			}

			return options;
		},
		formatOptions(_options, column_code){
			let self = this;
			let options = [];
			
			_.forEach(_options, function(option){
				options.push({
					value: option.value,
					label: self.i18n(option.name),
					color: option.color,
				});
			});
			return options;
		},
		getTheme(column){
			if(column.format == 'select_1'){
				return 'select-chips-outline';
			}else if(column.format == 'select_2'){
				return 'select-chips';
			}else if(column.format == 'select_3'){
				return 'chips-outline';
			}
			return 'default';
		},
		userDataUpdate(user, column, value){
			let user_id = user.user_id;
			let data = {
				[column]: value
			}

			let users = _.cloneDeep(this.users);
			let _user = users.find(__user => __user.user_id == user_id);
			_user[column] = {
				value
			}
			
			this.users = users;

			axios.put('api=inex/users/'+user_id+'/views/{view_code}', data).then(function (response) {
				console.log('==> response', response);
			}).catch(function (error) {
				console.log('==> error', error);
			})
		},
		sortColumn(column){
			this.sort = column;
			this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
		},
		getColumnStyle(column){
			let width = column?.width ? column.width.replace('px', '') : false;
			if(width !== false){
				width = parseInt(width) - 12;
				if(width > 0){
					width = width + 'px';
				}else{
					width = 0;
				}
			}else{
				width = 'auto';
			}

			let align = column?.align ? column.align : 'left';
			let justify = 'flex-start';
			if(align == 'center'){
				align = 'center';
				justify = 'center';
			}else if(align == 'right'){
				align = 'right';
				justify = 'flex-end';
			}else{
				align = 'left';
				justify = 'flex-start';
			}

			return {
				width,
				textAlign: align,
				justifyContent: justify
			}
		},
		getColumnClass(column){
			let _class = [];

			let align = column?.align ? column.align : 'left';
			switch(align){
				case 'center':
					_class.push('c');
					break;
				case 'right':
					_class.push('r');
					break;
				default:
					_class.push('l');
					break;
			}

			if(this.sortDirection == 'desc' && this.sort == column.code){
				_class.push('active_desc');
			}else if(this.sortDirection == 'asc' && this.sort == column.code){
				_class.push('active_asc');
			}

			return _class;
		}
	},
	computed:{
		getColumns(){
			return this.columns;
		},
		getFilters(){
			return this.columns.filter(column => column.filter == true && column.type == 'select');
		}
	},
	components:{
		SousMenu: () => import('./sous_menu.vue'),
		CustomInput,
		Select,
		Loading,
		LoadingBtn,
	}
}